import type { FunctionComponent, PropsWithChildren } from 'react'
import React, { createContext, useContext } from 'react'

import { invariant } from '@app/utils/invariant'

import type { RouterContextInterface } from './types'

const RouterContext = createContext<RouterContextInterface | null>(null)

export const RouterContextProvider: FunctionComponent<PropsWithChildren<RouterContextInterface>> = ({ children, ...ctx }) => {
  return <RouterContext value={ctx}>{children}</RouterContext>
}

export const useRouter = () => {
  return useContext(RouterContext) ?? invariant('RouterContext not provided')
}
